import * as React from "react"

const ECommerce = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 333.1 203.83" {...props}>
    <title>{"e-Commerce-Shipx-2"}</title>
    <path
      d="M311.79 14.38A14.38 14.38 0 0 0 297.41 0H35.7a14.38 14.38 0 0 0-14.39 14.37v167.08h290.48Zm-145.24-12a4.29 4.29 0 1 1-4.29 4.29 4.29 4.29 0 0 1 4.29-4.26ZM208.73 185.89c0 2.47-4 4.46-8.76 4.46h-66.84c-4.81 0-8.71-2-8.76-4.46H0a18 18 0 0 0 17.93 17.94h297.24a18 18 0 0 0 17.93-17.94Z"
      fill="#007f6e"
    />
    <rect
      x={34.71}
      y={13.39}
      width={263.68}
      height={154.66}
      rx={7.22}
      fill="#b1da00"
    />
    <path
      d="M200.55 106.55h-57a3.13 3.13 0 0 1-3-2.25l-11.21-38.16a1 1 0 0 0-.08-.25l-4.86-16.54h-14.15a3.14 3.14 0 0 1 0-6.28h16.46a3.13 3.13 0 0 1 3 2.25L134.6 62h76a3.12 3.12 0 0 1 3.1 3.16 2.86 2.86 0 0 1-.1.77l-10 38.29a3.13 3.13 0 0 1-3.05 2.33Zm-54.72-6.27h52.3l8.39-32h-70.1Z"
      fill="#fff"
    />
    <path
      d="M200.55 120.11h-65a9.92 9.92 0 1 1-.63-19.83h8.63a3.14 3.14 0 1 1 .35 6.27 2 2 0 0 1-.35 0h-8a3.64 3.64 0 0 0 0 7.28h65a3.14 3.14 0 0 1 0 6.28ZM146.39 124.82a8 8 0 1 0 8 8 8 8 0 0 0-8-8ZM189.55 124.82a8 8 0 1 0 8 8 8 8 0 0 0-8-8Z"
      fill="#fff"
    />
    <path
      d="M157.88 106.55a3.15 3.15 0 0 1-3.11-2.73l-4.9-38.29a3.141 3.141 0 0 1 6.18-1.13v.33L161 103a3.15 3.15 0 0 1-2.71 3.52ZM185.21 106.55h-.4a3.14 3.14 0 0 1-2.71-3.55l4.9-38.25a3.14 3.14 0 0 1 6.23.8l-4.91 38.29a3.13 3.13 0 0 1-3.11 2.71ZM171.55 106.55a3.15 3.15 0 0 1-3.14-3.14V65.13a3.14 3.14 0 1 1 6.27-.35 2 2 0 0 1 0 .35v38.28a3.13 3.13 0 0 1-3.12 3.14Z"
      fill="#fff"
    />
    <path
      d="M205.6 87.41h-67.71a3.14 3.14 0 1 1 0-6.28h67.71a3.14 3.14 0 1 1 0 6.28Z"
      fill="#fff"
    />
  </svg>
)

export default ECommerce
